import Image from 'next/image';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';
import LinesEllipsis from 'react-lines-ellipsis';
import { useAuth } from '../../../providers/AuthProvider';
import DateTimeFormatted from '../../General/DateTimeFormatted';

const InboxListItem = (props) => {
  const { chatroom, inbox } = props;
  const { isAdmin, uid } = useAuth();

  const linkHref = '/inbox/chat/[...id]';
  let linkAs = `/inbox/chat/${chatroom.id}`;

  if (isAdmin && inbox !== uid) {
    linkAs = `${linkAs}?uid=${inbox}`;
  }

  return (
    <Link legacyBehavior as={linkAs} href={linkHref} scroll={false}>
      <a
        className={`inbox-list-item-link ${
          chatroom.isRead ? 'is-read' : 'is-not-read'
        }`}
      >
        <div className="media">
          <figure className="media-left">
            <div className="image is-64x64">
              {chatroom.chatroomImage ? (
                <Image
                  src={chatroom.chatroomImage}
                  className="is-rounded"
                  alt={chatroom.chatroomName}
                  width={64}
                  height={64}
                />
              ) : (
                <Image
                  src={`${process.env.ASSET_PREFIX}/assets/svg/avatar.svg`}
                  className="is-rounded"
                  alt={chatroom.chatroomName}
                  width={64}
                  height={64}
                />
              )}
            </div>
          </figure>
          <div className="media-content">
            <div className="inbox-list-item-chatroom-name">
              <LinesEllipsis text={chatroom.chatroomName} maxLine={1} />
            </div>
            <div className="inbox-list-item-message">
              <LinesEllipsis text={chatroom.lastMessageContent} maxLine={3} />
            </div>
            {chatroom.lastMessageDate ? (
              <div className="inbox-list-item-date">
                <DateTimeFormatted timestamp={chatroom.lastMessageDate} />
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </a>
    </Link>
  );
};

InboxListItem.propTypes = {
  chatroom: PropTypes.object.isRequired,
  inbox: PropTypes.string.isRequired,
};

export default InboxListItem;
